export default "__VITE_ASSET__aa7f07b3__"